import { useController, UseControllerProps, useFormContext } from 'react-hook-form';

import { Select, SelectProps } from '../atomic/Select';

export type SelectControlledProps<T> = Omit<SelectProps<T>, 'onChange' | 'errorMessage' | 'value'> & {
  name: UseControllerProps['name'];
  rules?: UseControllerProps['rules'];
  defaultValue?: UseControllerProps['defaultValue'];
};

export const SelectControlled = <T extends { id: string }>({
  name,
  defaultValue = '',
  rules,
  ...rest
}: SelectControlledProps<T>) => {
  const { control } = useFormContext();

  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController({
    name,
    control,
    rules,
    defaultValue,
  });

  return <Select {...rest} errorMessage={error?.message} onChange={onChange} value={value} />;
};
